import _ from 'lodash';
import React from 'react';
import { FiPlus } from 'react-icons/fi';
import { CircleSpinner } from 'react-spinners-kit';
import styled from 'styled-components';
import { useUserRoles } from '../../../util/use-user-role';
import { DashboardWrapper } from '../../core/DashboardWrapper';
import { HorizontalContent } from '../../core/HorizontalContent';
import { Can } from '../../core/rbac/Can';
import { RhButton } from '../../core/RhButton';
import { RhCard } from '../../core/RhCard';
import { RhCardListItem } from '../../core/RhCardListItem';
import { SizedBox } from '../../core/SizedBox';
import { colors, H1, H2, H3 } from '../../core/Styles';
import { HomeProps } from '../containers/HomeContainer';

export const HomeScreen: React.FC<HomeProps> = props => {
  const { roles } = useUserRoles();

  return (
    <DashboardWrapper>
      <RhCard>
        <H1>Welcome to Risen Hope, {_.startCase(props.user?.nickname)}!</H1>
      </RhCard>
      <SizedBox height={24} />
      <Grid>
        <div>
          <RhCard>
            <HorizontalContent
              left={<H2>Upcoming Livestreams</H2>}
              right={[
                props.loadingEvents && <CircleSpinner key="events-spinner" size={15} color={colors.primary} />,
                <Can
                  key="add-event-button"
                  role={roles?.[0]}
                  perform="create:events"
                  yes={<RhButton onClick={props.userClickedAddEventButton} title="Add" suffixIcon={FiPlus} />}
                />,
              ]}
            />
            <Livestreams>
              {!props.upcomingEvents.length ? (
                <div>No upcoming livestreams</div>
              ) : (
                props.upcomingEvents.map(event => (
                  <RhCardListItem
                    key={event.id}
                    imageUrl={event.featuredImage.url}
                    startTime={event.startTime}
                    title={event.title}
                    authorLabelOverride="Led by:"
                    author={_.startCase(event.leader?.name)}
                    dateUpdated={event.dateUpdated}
                    description={event.description}
                    onClick={() => props.userClickedAnEvent(event.id)}
                  />
                ))
              )}
            </Livestreams>
          </RhCard>
        </div>
        <div>
          <Right>
            <Can
              role={roles?.[0]}
              perform="create:users"
              yes={
                <RhCard>
                  <H2>Spread the Word</H2>
                  <SizedBox height={16} />
                  <H3 weight="600">Want to add a person to the Risen Hope universe?</H3>
                  <SizedBox height={24} />
                  <RhButton title="Invite Someone" onClick={props.userClickedInviteUser} />
                </RhCard>
              }
            />
            {roles?.[0] !== 'Event Leader' && roles?.[0] !== 'Content Creator' && (
              <RhCard>
                <H2>Notifications</H2>
                <SizedBox height={16} />
                {/*<H3 weight="600">Voluptatum deleniti atque et quas molestias excepturi.</H3>*/}
                <SizedBox height={24} />
                <RhButton
                  title={roles?.[0] === 'Studier' ? 'Show Notification' : 'Send Notification'}
                  onClick={props.userClickedSendNotificationButton}
                />
              </RhCard>
            )}
          </Right>
        </div>
      </Grid>
    </DashboardWrapper>
  );
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 22px;
`;

const Right = styled.div`
  & > :not(:last-child) {
    margin-bottom: 24px;
  }
`;

const Livestreams = styled.div`
  margin-top: 14px;
  & > :not(:last-child) {
    margin-bottom: 20px;
  }
`;
